import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ActivatedRoute } from '@angular/router';
import { Params, Router } from '@angular/router';
import { ConsumersService } from '../consumers.service';

@Component({
  selector: 'app-manage-consumers',
  templateUrl: './manage-consumers.component.html',
  styleUrls: ['./manage-consumers.component.scss']
})
export class ManageConsumersComponent extends FeaturesBaseComponent implements OnInit {
  userId;
  currentRoute

  constructor(private consumerService:ConsumersService, private router: Router, private activeRoute:ActivatedRoute) {
    super();
    this.userId = this.activeRoute.snapshot.params.userId;
  }

  ngOnInit(): void {

    super.ngOnInit();
    this.router.navigate([`/features/consumers/manage-consumers/${this.userId}/edit-consumer/${this.userId}`])
  }

}
